import React from 'react'
import { t } from 'ttag'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { updateSelectedFilters } from 'store/actions/filters'
import Button from 'components/ui/Button'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'

function SearchableMultiSelectHigherLevel({
  type,
  filterData,
  values,
  title,
  onClose,
  showFilter,
  keyWord,
  customTop
}) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const filterObject = filters.selectedFilters[currentSearchable][type]
  return (
    <PureSearchableMultiSelectHigherLevel
      type={type}
      values={values}
      filterData={filterData}
      title={title}
      onClose={onClose}
      showFilter={showFilter}
      keyWord={keyWord}
      customTop={customTop}
      filterObject={filterObject}
    />
  )
}

const PureSearchableMultiSelectHigherLevel = React.memo(
  function PureSearchableMultiSelectHigherLevel({
    type,
    filterData,
    values,
    title,
    onClose,
    showFilter,
    keyWord,
    customTop,
    filterObject
  }) {
    const dispatch = useDispatch()
    const selectedValues = filterObject

    const options = filterData.map(option => {
      const parentOption = {
        label: option[keyWord],
        value: option.id,
        expanded: true
      }
      const selectedOption = selectedValues.filter(
        s => s.id === option.id && s.label === option[keyWord]
      )
      if (selectedOption.length > 0) {
        parentOption.checked = true
      }
      return parentOption
    })

    const onChange = (currentNode, selectedNodes) => {
      const filterValue = selectedNodes.map(node => ({
        id: node.value,
        label: node.label
      }))

      const data = {
        filterType: type,
        filterId: type,
        filterValue,
        isHigherLevelFilter: true
      }
      dispatch(updateSelectedFilters(data))
    }

    function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
      let resultingValue = null
      if (valueIsArray) {
        resultingValue = filterObject.filter(s => s.id !== filterValue.id || s !== filterValue)
      }
      const data = {
        filterType: type,
        filterId,
        filterValue: resultingValue,
        isHigherLevelFilter: true
      }
      dispatch(updateSelectedFilters(data))
    }

    function renderSelectedValues() {
      return values.map(value => {
        if (filterObject) {
          const filterValue = filterObject
          if (filterValue instanceof Array) {
            return filterValue.map(v => (
              <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
                <SelectedFilter>
                  <FilterText title={v.label ? v.label : v}>
                    <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.label ? v.label : v}</Dotdotdot>
                  </FilterText>
                  <RemoveIcon
                    className="far fa-times"
                    onClick={() => handleFilterRemove(value, v, true)}
                  />
                </SelectedFilter>
              </SelectedFilterContainer>
            ))
          }
        }
        return false
      })
    }

    return (
      <>
        <SearchFilter open={showFilter} customTop={customTop}>
          <FilterTitle>{title}</FilterTitle>
          <CustomDropDownTreeSelect data={options} onChange={onChange} />
          <Button size="medium" onClick={onClose}>
            {t`Close`}
          </Button>
        </SearchFilter>
        <div>{renderSelectedValues()}</div>
      </>
    )
  }
)

SearchableMultiSelectHigherLevel.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  keyWord: PropTypes.string,
  customTop: PropTypes.string
}

PureSearchableMultiSelectHigherLevel.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  keyWord: PropTypes.string,
  customTop: PropTypes.string,
  filterObject: PropTypes.array
}

export default SearchableMultiSelectHigherLevel
